import React, { ReactNode, useEffect, useState } from 'react'
import styled from 'styled-components'
import { BUTTON_ACTIVE_OPACITY } from '../constants'
import CreationToolGradient from '../types/gradient'
import CreationToolUIAnimation from '../types/ui-animation'
import { GradientBlock } from './blocks'
import { Subtitle } from './typography'

const Container = styled.div`
    background: #000;
    border-radius: 17px;
    color: #fff;
    display: flex;
    height: 34px;
    position: relative;
    width: 100%;
`

const Item = styled(Subtitle as any)`
    align-items: center;
    border-radius: inherit;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    margin: 0;
    position: relative;
    user-select: none;
    width: 100%;

    &:active {
        opacity: ${BUTTON_ACTIVE_OPACITY};
    }

    span {
        pointer-events: none;
        position: relative;
    }
`

const GradientWrapper = styled.div`
    ${CreationToolUIAnimation.css(CreationToolUIAnimation.PopIn)}
    border-radius: inherit;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;

    ${GradientBlock} {
        border-radius: inherit;
        height: 100%;
        width: 100%;
    }
`

type Props = {
    className?: string
    items: (string | ReactNode)[]
    defaultIndex?: number
    gradient?: CreationToolGradient
    onIndexChange: (index: number) => void
}

const CreationToolsSegmentedControl = ({ className, items, defaultIndex = 0, gradient, onIndexChange }: Props) => {
    const [activeIndex, setActiveIndex] = useState<number>(defaultIndex)

    useEffect(() => {
        onIndexChange(activeIndex)
    }, [activeIndex, onIndexChange])

    return (
        <Container className={className}>
            {items.map((label: ReactNode, i) => (
                <Item
                    key={`segmented-control-item-${i}`}
                    style={gradient ? {} : { color: i === activeIndex ? '#000' : '' }}
                    onClick={() => setActiveIndex(i)}
                >
                    {i === activeIndex && (
                        <GradientWrapper style={gradient ? {} : { background: '#fff' }}>
                            {gradient && <GradientBlock colors={CreationToolGradient.colors(gradient)} />}
                        </GradientWrapper>
                    )}
                    <span>{label}</span>
                </Item>
            ))}
        </Container>
    )
}

export default CreationToolsSegmentedControl
